<template>
  <div class="base-input"
       :class="`${name} ${classes} ${required ? 'required-field': ''}`">
    <slot name="label" :id="id || name">
      <label v-show="label"
            :for="id || name">
        {{ label }}
      </label>
    </slot>
    <slot name="before"/>
    <textarea v-if="type === 'textarea'"
              ref="inputRef"
              :id="id || name"
              :name="name"
              class="w100"
              :placeholder="placeholder || name"
              :disabled="disabled"
              :value="value"
              :cy="name"
              @input="handleInput" />
    <input v-else
           ref="inputRef"
           :min="min"
           :max="max"
           :type="type || 'text'"
           class="w100"
           :id="id || name"
           :value="value"
           :cy="name"
           :placeholder="placeholder || name"
           :disabled="disabled"
           @keyup.enter="handleEnterKey"
           @input="handleInput" />
    <slot />
  </div>
</template>

<script setup>
  import { ref } from 'vue'

  const props = defineProps({
    name: String,
    label: String,
    type: String,
    id: String,
    classes: {type: String, default: ""},
    value: [String, Number, Array],
    placeholder: String,
    disabled: Boolean,
    required: Boolean,
    min: Number,
    max: Number,
  })

  const emits = defineEmits(['input', 'enter'])
  const inputRef = ref(null)

  function handleInput ({target}) {
    emits('input', {name: props.name, value: target.value})
  }

  function handleEnterKey () {
    emits('enter', {name: props.name})
  }

  defineExpose({
    focus: () => inputRef.value?.focus(),
    inputRef
  })
</script>

<style lang="scss">
  @import "../styles/vars";

  .base-input {
    input,
    textarea {
      border-radius: 4px;
      border: 0.5px solid black;
    }
    input {
      padding: 15px 30px;
      font-size: 1.4rem;
      font-weight: 700;
      &::placeholder {
        color: $gray;
      }
    }
    textarea {
      padding: 8px 18px;
      line-height: 2.4rem;
    }
    &.required-field {
      input, textarea {
        border: 1px solid red;
      }
    }
  }
</style>